var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    {
      staticClass: "ma-0 pa-0 mt-10 mb-10",
      staticStyle: { "font-weight": "500" },
      attrs: { justify: "space-between" },
    },
    [
      _c(
        "v-col",
        {
          staticClass: "ma-0 pa-0",
          staticStyle: { "text-align": "start", "font-size": "0.9rem" },
          attrs: { cols: "8" },
        },
        [
          _c("v-row", { staticClass: "ma-0 pa-0" }, [
            _vm._v(" ＜利用上の注意＞ "),
          ]),
          _c("v-row", { staticClass: "ma-0 pa-0 pb-2" }, [
            _vm._v(
              " ※構成比は小数点以下を四捨五入しているため、合計しても必ずしも100％とはならない場合があります。 "
            ),
          ]),
          _c("v-row", { staticClass: "ma-0 pa-0" }, [
            _vm._v(
              " ※当日の時間別集計の数値は、カメラからのデータが時間を跨いで遅れて受信する場合等に多少の誤差が発生する場合がありますので予めご了承ください。 "
            ),
          ]),
          _c("v-row", { staticClass: "ma-0 pa-0 pl-4" }, [
            _vm._v(
              " 尚、毎日深夜1時5分より前日分のデータを再計算してグラフを再表示していますので、より正確な数値を確認したい場合は、翌日2：00以降に表示されるデータをご利用ください。 "
            ),
          ]),
        ],
        1
      ),
      _vm.fileDownloadStatus == "makeFile"
        ? _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0",
              staticStyle: {
                "text-decoration": "underline",
                color: "#008DD0",
                cursor: "pointer",
              },
              attrs: { cols: "auto" },
              on: { click: _vm.clickFileDownload },
            },
            [_vm._v(" " + _vm._s(_vm.ta("fileDownload")) + " ")]
          )
        : _vm.fileDownloadStatus == "filePreparing"
        ? _c(
            "v-col",
            { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  staticStyle: { position: "relative" },
                },
                [
                  _c("v-img", {
                    staticClass: "progress_circle",
                    attrs: {
                      src: require("@/assets/images/progress_circle.gif"),
                    },
                  }),
                  _vm._v(" " + _vm._s(_vm.ta("filePreparing")) + " "),
                ],
                1
              ),
            ],
            1
          )
        : _vm.fileDownloadStatus == "downloadReady"
        ? _c(
            "v-col",
            { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0 mb-2",
                  staticStyle: { "font-size": "0.9rem" },
                  attrs: { justify: "end" },
                },
                [_vm._v(" " + _vm._s(_vm.ta("downloadReady")) + " ")]
              ),
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0", attrs: { justify: "end" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "ma-0 pa-0", attrs: { justify: "end" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "ma-0 pa-0" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "pa-5 pl-15 pr-15",
                                  staticStyle: { "font-size": "1.1rem" },
                                  attrs: {
                                    id: "blue_btn",
                                    href: _vm.fileDownloadLink,
                                    download: "",
                                  },
                                  on: { click: _vm.toDownloadSuccess },
                                },
                                [
                                  _c("v-img", {
                                    attrs: {
                                      src: require("@/assets/images/icon_file_download.png"),
                                      width: "1.5rem",
                                    },
                                  }),
                                  _vm._v(
                                    " " + _vm._s(_vm.ta("csvDownload")) + " "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0 mt-2 modeText",
                          attrs: { justify: "start" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pl-2",
                              attrs: { cols: "3" },
                            },
                            [_vm._v(" " + _vm._s(_vm.ta("period")) + " : ")]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "9", "align-self": "start" },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.getDateToTextFormat()) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0 modeText",
                          attrs: { justify: "start" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pl-2",
                              attrs: { cols: "3" },
                            },
                            [_vm._v(" " + _vm._s(_vm.ta("mode")) + " : ")]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "9", "align-self": "start" },
                            },
                            [_vm._v(" " + _vm._s(_vm.modeText) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.fileDownloadStatus == "downloadFail"
        ? _c(
            "v-col",
            [
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0 mb-2", attrs: { justify: "end" } },
                [_vm._v(" " + _vm._s(_vm.ta("downloadRetry")) + " ")]
              ),
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0", attrs: { justify: "end" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "ma-0 pa-0", attrs: { justify: "end" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "pa-5 pl-11 pr-11",
                              staticStyle: {
                                "border-radius": "0px",
                                "font-size": "1.1rem",
                              },
                              attrs: { id: "grey_btn" },
                              on: { click: _vm.toMakeFile },
                            },
                            [
                              _c("v-img", {
                                staticClass: "mr-1",
                                staticStyle: { width: "2rem" },
                                attrs: {
                                  src: require("@/assets/images/icon_warning.png"),
                                },
                              }),
                              _vm._v(
                                " " + _vm._s(_vm.ta("downloadFail")) + " "
                              ),
                              _c("v-img", {
                                staticClass: "btn_close",
                                staticStyle: { right: "-2.7rem" },
                                attrs: {
                                  src: require("@/assets/images/popup_close.png"),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.fileDownloadStatus == "downloadSuccess"
        ? _c(
            "v-col",
            [
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0", attrs: { justify: "end" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "pl-10 pr-10",
                      staticStyle: { "border-radius": "0px" },
                      attrs: { id: "grey_btn" },
                      on: { click: _vm.toMakeFile },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.ta("downloadSuccess")) + " "),
                      _c("v-img", {
                        staticClass: "btn_close",
                        attrs: {
                          src: require("@/assets/images/popup_close.png"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }